import { createContext, useContext } from "react";

/**
 * * See AuthProvider.jsx
 */
export class Auth {
  /** {
    "https://staging.esg360.io/user_authorization": [
        "ORG_ADMIN",
        "DEV",
        "ESG_ADMIN"
    ],
    "nickname": ,
    "name": ,
    "picture": 
    "updated_at": "2025-06-04T12:50:09.365Z",
    "email": 
    "email_verified": 
    "sub": "auth0|XXX", This is the user id
    "org_id": 
} */
  user;
  userPermissions;
  /** @type {() => void} */
  logout;
  /**
   * Call getAccessTokenSilently() then `method(params, accessToken)` or `method(accessToken)` if no params are provided.
   *
   * The access token is from Auth0 - opening authorize in a popup if needed.
   * @type {(method: any, params?: any) => Promise<any>} 	*/
  callApi;

  /** @type {() => Promise<string>} */
  getAccessTokenSilently;
}

/**
 * @type {React.Context<Auth>}
 */
export const AUTH_CONTEXT = createContext();

/**
 * See AuthProvider.jsx
 * @returns {Auth}
 */
export function useAuth() {
  const context = useContext(AUTH_CONTEXT);

  // if (!context) {
  //   throw new Error('useAuth must be used inside AuthProvider');
  // }
  return context;
}
